<template>
    <div class="item-card item-card--transfer-type">
        <!-- Icon -->
        <i class="icon " :class="[ item.icon ]"></i>

        <!-- Name -->
        <span class="name">
            {{ item.name }}
        </span>

        <!-- Description -->
        <small class="description" v-if="item.description">
            {{ item.description }}
        </small>
    </div>
</template>

<script>
    export default {
        props: ['item'],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {},
        watch: {}
    }
</script>
